import React, { useEffect, useRef, useState } from 'react';
import { IconButton, icons, Loader } from '@ublend-npm/aulaui-next';
import { Lti1p3Form } from '../Lti1p3Launch/Lti1p3Form';
import { LtiRequestType } from '../Lti1p3Launch/types';
import {
  ContentContainer,
  ContentHeader,
  ContentHeaderContainer,
  IFrame,
  LoaderContainer,
  StyledModal,
} from './Lti1p3EmbedModal.styled';

export type Lti1p3EmbedModalProps = {
  title: string;
  loginUrl: string;
  targetUrl: string;
  clientId: string;
  iss: string;
  loginHint: string;
  type: LtiRequestType;
  onClose: () => void;
};

/**
 * True in-app embed for Resource Link launches when Admin launch container is iframe.
 * Replaces navigating the whole Aula tab with target=_self.
 */
export const Lti1p3EmbedModal = ({
  title,
  loginUrl,
  targetUrl,
  clientId,
  iss,
  loginHint,
  type,
  onClose,
}: Lti1p3EmbedModalProps) => {
  const iframeId = 'assignment-lti-embed-frame';
  const spinnerSize = 50;
  const centerOffset = `${spinnerSize / 2}px`;
  const formRef = useRef<HTMLFormElement | null>(null);
  const [hasIframeLoaded, setHasIframeLoaded] = useState(false);
  const hasSubmittedRef = useRef(false);

  useEffect(() => {
    if (loginHint && formRef.current && !hasSubmittedRef.current) {
      hasSubmittedRef.current = true;
      formRef.current.requestSubmit();
    }
  }, [loginHint]);

  return (
    <StyledModal
      open
      id="assignment-lti-embed-modal"
      size="default"
      onClose={onClose}
    >
      <ContentContainer>
        <ContentHeaderContainer>
          <ContentHeader>{title}</ContentHeader>
          <IconButton
            style={{ color: 'black' }}
            size={24}
            label="Close"
            icon={icons.Close}
            type="secondary"
            onClick={onClose}
            data-testid="close-assignment-lti-embed-modal"
          />
        </ContentHeaderContainer>
        {!hasIframeLoaded && (
          <LoaderContainer centerOffset={centerOffset}>
            <Loader size={spinnerSize} />
          </LoaderContainer>
        )}
        <Lti1p3Form
          ref={formRef}
          loginUrl={loginUrl}
          targetUrl={targetUrl}
          clientId={clientId}
          iss={iss}
          type={type}
          loginHint={loginHint}
          target={iframeId}
        />
        <IFrame
          id={iframeId}
          name={iframeId}
          title={title}
          allow="fullscreen"
          data-testid="assignment-lti-embed-iframe"
          onLoad={() => setHasIframeLoaded(true)}
        />
      </ContentContainer>
    </StyledModal>
  );
};

export default Lti1p3EmbedModal;
